"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTriplets = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const views_1 = require("./views");
const productTile_1 = require("../productTile");
function ProductTriplets({ ids, take, tileRenderer, startFromRight, className, }) {
    const { data } = (0, app_1.useQuery)('getProducts', {
        args: Object.assign(Object.assign({}, (ids && { ids })), (take && { take })),
        select: productTile_1.PRODUCT_TILE_DATA_SELECT,
    });
    if (!data) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(views_1.ProductTripletsView, { startFromRight: startFromRight, tileRenderer: tileRenderer, className: className, products: data }));
}
exports.ProductTriplets = ProductTriplets;
